<template>
<div class="walk-wrapper">
  <div class="walk-detail" :style="iphoneX ? `height: calc(100vh - ${offset}px - 195px - 34px)` : `height: calc(100vh - ${offset}px - 195px)`" ref="wrapper">
    <cube-scroll ref="scroll"
                 :scroll-events="['scroll']"
                 @scroll="handleScroll"
                 :data="route.paths[0].instructions"
                 class="horizontal-scroll-list-wrap">
      <div class="item">
        <div class="item-content">
          <div class="icon start">
            <div class="start-icon">{{ $t('navigate.startIcon') }}</div>
          </div>
          <div class="item-info">{{ $t('navigate.start') }}({{ startName || $t('common.myLocation') }})</div>
        </div>
      </div>
      <div class="item"
          v-for="(item, index) in route.paths[0].instructions"
          :key="`item-${index}`">
        <div class="item-content" v-if="processText(item.text) === 'continue'">
          <div class="icon">
            <img src="/image/navigate/straight-line.svg" />
          </div>
          <div class="item-info">{{ $t("navigate.distanceMsg", { distance: formatDistance(item.distance) }) }}<span class="dark ml-10">{{ $t('navigate.continue') }}</span><span v-if="item.street_name" class="ml-10">{{ $t('navigate.enter') }} <span class="dark">{{ item.street_name }}</span></span></div>
        </div>
        <div class="item-content" v-else-if="processText(item.text) === 'turn-right'">
          <div class="icon">
            <img src="/image/navigate/turn-right.svg"  />
          </div>
          <div class="item-info">{{ $t("navigate.distanceMsg", { distance: formatDistance(item.distance) }) }}<span class="dark ml-10">{{ $t('navigate.turnRight') }}</span><span v-if="item.street_name"> {{ $t('navigate.enter') }} <span class="dark">{{ item.street_name }}</span></span></div>
        </div>
        <div class="item-content" v-else-if="processText(item.text) === 'turn-left'">
          <div class="icon">
            <img src="/image/navigate/turn-right.svg" class="reverse"  />
          </div>
          <div class="item-info">{{ $t("navigate.distanceMsg", { distance: formatDistance(item.distance) }) }}<span class="dark ml-10">{{ $t('navigate.turnLeft') }}</span><span v-if="item.street_name"> {{ $t('navigate.enter') }} <span class="dark">{{ item.street_name }}</span></span></div>
        </div>
        <div class="item-content" v-else-if="processText(item.text) === 'turn-slight-left'">
          <div class="icon">
            <img src="/image/navigate/left-front.svg"  />
          </div>
          <div class="item-info">{{ $t("navigate.distanceMsg", { distance: formatDistance(item.distance) }) }}<span class="dark ml-10">{{ $t('navigate.turnSlightLeft') }}</span><span v-if="item.street_name"> {{ $t('navigate.enter') }} <span class="dark">{{ item.street_name }}</span></span></div>
        </div>
        <div class="item-content" v-else-if="processText(item.text) === 'turn-slight-right'">
          <div class="icon">
            <img src="/image/navigate/left-front.svg" class="reverse" />
          </div>
          <div class="item-info">{{ $t("navigate.distanceMsg", { distance: formatDistance(item.distance) }) }}<span class="dark ml-10">{{ $t('navigate.turnSlightRight') }}</span><span v-if="item.street_name"> {{ $t('navigate.enter') }} <span class="dark">{{ item.street_name }}</span></span></div>
        </div>
        <div class="item-content" v-else-if="processText(item.text) === 'turn-sharp-right'">
          <div class="icon">
            <img src="/image/navigate/right-back.svg"  />
          </div>
          <div class="item-info"><span class="dark">{{ $t('navigate.turnSharpRight') }}</span></div>
        </div>
        <div class="item-content" v-else-if="processText(item.text) === 'turn-sharp-left'">
          <div class="icon">
            <img src="/image/navigate/right-back.svg" class="reverse" />
          </div>
          <div class="item-info"><span class="dark">{{ $t('navigate.turnSharpLeft') }}</span></div>
        </div>
        <div class="item-content" v-else-if="processText(item.text) === 'finish'">
          <div class="icon">
            <img src="/image/navigate/straight-line.svg" />
          </div>
          <div class="item-info">{{ $t("navigate.arriveNote", { distance: formatDistance(item.distance) }) }}</div>
        </div>
        <div class="item-content" v-else>
          <div class="item-info">{{ $t("navigate.distanceMsg", { distance: formatDistance(item.distance) }) }}{{ item.text }}</div>
        </div>
      </div>
      <div class="item">
        <div class="item-content">
          <div class="icon end">
            <div class="start-icon end">{{ $t('navigate.endIcon') }}</div>
          </div>
          <div class="item-info">{{ $t('navigate.endPoint') }} <span class="dark">{{ endName }}</span></div>
        </div>
      </div>
      <div class="empty-node" v-if="safari" style="height: 50px"></div>
    </cube-scroll>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      scrollTop: 0
    }
  },
  computed: {
    safari () {
      return this.$store.state.safari
    }
  },
  props: {
    route: {
      type: Object,
      default: () => {
        return {}
      }
    },
    startName: {
      type: String,
      default: ''
    },
    endName: {
      type: String,
      default: ''
    },
    offset: {
      type: Number,
      default: 0
    },
    iphoneX: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleScroll (e) {
      this.scrollTop = e.y
    },
    formatDistance (val) {
      let s = ''
      if (val < 1000) {
        s = Math.round(val) + this.$t('common.metre')
      } else {
        s = Math.round(parseInt(val * 10) / 1000) / 10
        s += this.$t('common.kilometre')
      }
      return s
    },
    processText (text) {
      const string = text.toLowerCase()
      if (/continue/.test(string)) {
        return 'continue'
      } else if (/turn right/.test(string)) {
        return 'turn-right'
      } else if (/turn left/.test(string)) {
        return 'turn-left'
      } else if (/turn slight right/.test(string)) {
        return 'turn-slight-right'
      } else if (/turn slight left/.test(string)) {
        return 'turn-slight-left'
      } else if (/turn sharp left/.test(string)) {
        return 'turn-sharp-left'
      } else if (/turn sharp right/.test(string)) {
        return 'turn-sharp-right'
      } else if (/finish/.test(string)) {
        return 'finish'
      } else {
        return text
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.walk-detail {
  margin-bottom: 37px;
  margin-bottom: calc(env(safe-area-inset-bottom) + 37px);
  // overflow: auto;

  .item-content {
    display: flex;
    align-items: center;
  }

  .icon {
    width: 18px;
    height: 23px;
    display: block;
    align-items: center;
    justify-content: center;
    margin-left: 26px;

    &.start,
    &.end {
      height: 18px;
    }
  }

  img {
    display: block;
    &.reverse {
      transform: rotateY(180deg);
    }
  }

  .item {
    &:not(:last-child) {
      .item-info {
        border-bottom: solid 1px #efefef;
      }
    }

    &-info {
      flex: 1;
      margin-left: 38px;
      font-size: 16px;
      color: #888888;
      line-height: 22px;
      padding: 16px 10px 16px 0;

      .dark {
        color: #222125;
      }

      .ml-10 {
        margin-left: 10px;
        display: inline-block;
      }

      .mr-10 {
        margin-right: 10px;
        display: inline-block;
      }
    }

    .start-icon {
      width: 18px;
      height: 18px;
      background-color: #00a1a7;
      border-radius: 50%;
      font-size: 12px;
      line-height: 12px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;

      &.end {
        background-color: #ee7459;
      }
    }
  }
}
</style>
